import type { LinkPreview } from '@/api/types'

/**
 * 链接预览卡。
 *
 * 图片由浏览器直接从对方站点加载（后端只存 URL 不做代理），所以加
 * `referrerPolicy=no-referrer`：不把用户在看哪条帖子告诉对方站点。
 */
export function LinkPreviewCard({ preview }: { preview: LinkPreview }) {
  const host = safeHost(preview.url)

  return (
    <a
      href={preview.url}
      target="_blank"
      rel="noopener noreferrer nofollow ugc"
      onClick={(event) => event.stopPropagation()}
      className="mt-3 block overflow-hidden rounded-md border border-line transition-colors hover:bg-surface-hover"
    >
      {preview.image_url && (
        <img
          src={preview.image_url}
          alt=""
          loading="lazy"
          referrerPolicy="no-referrer"
          className="aspect-[1.91/1] w-full bg-surface-subtle object-cover"
        />
      )}
      <div className="px-3 py-2">
        <p className="text-[13px] text-ink-muted">{preview.site_name || host}</p>
        {preview.title && (
          <p className="mt-0.5 line-clamp-1 text-[15px] font-bold">{preview.title}</p>
        )}
        {preview.description && (
          <p className="mt-0.5 line-clamp-2 text-[15px] text-ink-muted">{preview.description}</p>
        )}
      </div>
    </a>
  )
}

function safeHost(url: string): string {
  try {
    return new URL(url).host
  } catch {
    return url
  }
}
